import { gql } from '@apollo/client';

export const InsertInventoryOrderWithInventoryMutation = gql`
  mutation InsertInventoryOrderWithInventoryMutation(
    $practiceId: uuid!
    $amount: numeric!
    $date: timestamptz!
    $doses: Int!
    $inventoryExpiration: date
    $invoiceDue: date
    $orderNumber: String
    $lot: String
    $statusOrder: order_statuses_enum!
    $statusInventory: inventory_statuses_enum!
    $statusLog: jsonb!
    $vaccineId: uuid!
    $vfc: Boolean!
  ) {
    insert_inventory_orders_one(
      object: {
        practiceId: $practiceId
        amount: $amount
        date: $date
        doses: $doses
        inventoryExpiration: $inventoryExpiration
        lot: $lot
        status: $statusOrder
        statusLog: $statusLog
        vaccineId: $vaccineId
        vfc: $vfc
        inventory: {
          data: {
            practiceId: $practiceId
            vaccineId: $vaccineId
            lot: $lot
            expiration: $inventoryExpiration
            status: $statusInventory
            doses: $doses
            vfc: $vfc
          }
        }
      }
    ) {
      id
    }
  }
`;
